/**
 * Static index of admin pages for client-side "jump to page" search.
 * Paths that need the logged-in admin userId use `{userId}` placeholder.
 */
const pageSearchIndex = [
  {
    id: "welcome",
    labelKey: "welcome",
    descriptionKey: "page_desc_welcome",
    path: "/admin/welcome",
    keywords: ["welcome", "home", "dashboard", "overview", "metrics"],
  },
  {
    id: "prescriberDashboard",
    labelKey: "prescriber_dashboard",
    descriptionKey: "page_desc_prescriber_dashboard",
    path: "/prescriber/dashboard",
    keywords: [
      "prescriber",
      "dashboard",
      "prescriptions",
      "invites",
      "monitor",
      "sayn pro",
    ],
  },
  {
    id: "history",
    labelKey: "history",
    descriptionKey: "page_desc_history",
    path: "/user/{userId}/answer-questionnaire/history",
    keywords: ["history", "analyses", "analysis", "questionnaire answers", "status"],
  },
  {
    id: "answerQuestionnaire",
    labelKey: "questionnaire",
    descriptionKey: "page_desc_questionnaire",
    path: "/user/{userId}/answer-questionnaire",
    keywords: ["new", "questionnaire", "analysis", "start", "invite", "pre-pay"],
  },
  {
    id: "invites",
    labelKey: "invitesMenu",
    descriptionKey: "page_desc_invites",
    path: "/admin/invites",
    keywords: ["invites", "invitations", "links", "resend", "email"],
  },
  {
    id: "pacients",
    labelKey: "pacients",
    descriptionKey: "page_desc_pacients",
    path: "/admin/pacients",
    keywords: ["patients", "pacients", "users", "edit", "delete"],
  },
  {
    id: "prescribers",
    labelKey: "companyUsersMenu",
    descriptionKey: "page_desc_prescribers",
    path: "/admin/prescribers",
    keywords: ["prescribers", "doctors", "professionals", "accounts"],
  },
  {
    id: "companies",
    labelKey: "companies",
    descriptionKey: "page_desc_companies",
    path: "/admin/companies",
    keywords: ["companies", "practices", "fees", "stripe", "owners"],
  },
  {
    id: "usersBackoffice",
    labelKey: "userBackofficeMenu",
    descriptionKey: "page_desc_users_backoffice",
    path: "/admin/users/backoffice",
    keywords: ["backoffice", "consultants", "admin users", "admins"],
  },
  {
    id: "usersApp",
    labelKey: "userAppMenu",
    descriptionKey: "page_desc_users_app",
    path: "/admin/users/app",
    keywords: ["app users", "mobile users"],
  },
  {
    id: "reports",
    labelKey: "reports",
    descriptionKey: "page_desc_reports",
    path: "/admin/reports",
    keywords: ["reports", "content", "texts", "options"],
  },
  {
    id: "emailTemplates",
    labelKey: "emailTemplates",
    descriptionKey: "page_desc_email_templates",
    path: "/admin/email-templates",
    keywords: ["email", "templates", "mail"],
  },
  {
    id: "customTexts",
    labelKey: "customTexts",
    descriptionKey: "page_desc_custom_texts",
    path: "/admin/custom-texts",
    keywords: ["custom texts", "strings", "content"],
  },
  {
    id: "pushNotifications",
    labelKey: "push_notifications",
    descriptionKey: "page_desc_push_notifications",
    path: "/admin/push-notifications",
    keywords: ["push", "notifications"],
  },
  {
    id: "settings",
    labelKey: "settingsMenu",
    descriptionKey: "page_desc_settings",
    path: "/admin/backoffice-values",
    keywords: ["settings", "backoffice values", "editable values", "constants"],
  },
  {
    id: "questionnaires",
    labelKey: "questionnairesMenu",
    descriptionKey: "page_desc_questionnaires",
    path: "/admin/questionnaires",
    keywords: ["questionnaires", "database", "create"],
  },
  {
    id: "questions",
    labelKey: "questionsMenu",
    descriptionKey: "page_desc_questions",
    path: "/admin/questions",
    keywords: ["questions", "database", "create"],
  },
  {
    id: "answersOptions",
    labelKey: "answer_options",
    descriptionKey: "page_desc_answer_options",
    path: "/admin/answers-options",
    keywords: ["answer options", "answers", "database"],
  },
  {
    id: "textConfigCriteria",
    labelKey: "textConfigMenu",
    path: "/admin/text-config/criteria",
    keywords: ["text config", "criteria", "database"],
  },
  {
    id: "gallery",
    labelKey: "gallery",
    descriptionKey: "page_desc_gallery",
    path: "/admin/gallery",
    keywords: ["gallery", "images", "upload"],
  },
  {
    id: "criteria",
    labelKey: "criteriaMenu",
    descriptionKey: "page_desc_criteria",
    path: "/admin/criteria",
    keywords: ["criteria", "algorithm"],
  },
  {
    id: "criteriaUsage",
    labelKey: "criteriaUsageMenu",
    descriptionKey: "page_desc_criteria_usage",
    path: "/admin/criteria-usage",
    keywords: ["criteria usage", "algorithm"],
  },
  {
    id: "metaSkill",
    labelKey: "metaSkillMenu",
    descriptionKey: "page_desc_meta_skill",
    path: "/admin/meta-skill",
    keywords: ["meta skills", "meta-skill", "algorithm"],
  },
  {
    id: "principle",
    labelKey: "principleMenu",
    descriptionKey: "page_desc_principle",
    path: "/admin/principle",
    keywords: ["principles", "algorithm"],
  },
  {
    id: "algorithmConfig",
    labelKey: "algorithm_config",
    descriptionKey: "page_desc_algorithm_config",
    path: "/admin/algorithm-config",
    keywords: ["algorithm config", "configuration", "algorithm"],
  },
  {
    id: "element",
    labelKey: "elementMenu",
    descriptionKey: "page_desc_element",
    path: "/admin/elements",
    keywords: ["elements", "algorithm"],
  },
  {
    id: "feeling",
    labelKey: "feelingsMenu",
    descriptionKey: "page_desc_feeling",
    path: "/admin/feelings",
    keywords: ["feelings", "attributes"],
  },
  {
    id: "organ",
    labelKey: "organsMenu",
    descriptionKey: "page_desc_organ",
    path: "/admin/organs",
    keywords: ["organs", "attributes"],
  },
  {
    id: "season",
    labelKey: "seasonMenu",
    descriptionKey: "page_desc_season",
    path: "/admin/seasons",
    keywords: ["seasons", "attributes"],
  },
  {
    id: "naturalElement",
    labelKey: "naturalElementMenu",
    descriptionKey: "page_desc_natural_element",
    path: "/admin/natural-elements",
    keywords: ["natural elements", "attributes"],
  },
  {
    id: "character",
    labelKey: "characterMenu",
    descriptionKey: "page_desc_character",
    path: "/admin/characters",
    keywords: ["characters", "attributes"],
  },
  {
    id: "input",
    labelKey: "inputMenu",
    descriptionKey: "page_desc_input",
    path: "/admin/input",
    keywords: ["inputs", "images"],
  },
  {
    id: "algorithmOutput",
    labelKey: "algorithmOutputMenu",
    descriptionKey: "page_desc_algorithm_output",
    path: "/admin/algorithm-output",
    keywords: ["algorithm output", "outputs"],
  },
  {
    id: "generalOutput",
    labelKey: "generalOutputMenu",
    descriptionKey: "page_desc_general_output",
    path: "/admin/general-output",
    keywords: ["general output", "outputs"],
  },
  {
    id: "app",
    labelKey: "mobileApkMenu",
    descriptionKey: "page_desc_mobile_apps",
    path: "/admin/mobile-apps",
    keywords: ["mobile apps", "apk", "apps"],
  },
  {
    id: "criteriaManagement",
    labelKey: "criteriaManagementMenu",
    descriptionKey: "page_desc_criteria_management",
    path: "/admin/criteria-management",
    keywords: ["criteria management"],
  },
];

export function filterPages(term, translate, userId) {
  const query = (term || "").trim().toLowerCase();
  if (!query) {
    return [];
  }

  return pageSearchIndex
    .map((page) => {
      const label = translate(page.labelKey);
      const description = page.descriptionKey
        ? translate(page.descriptionKey)
        : "";
      const haystack = [label, description, ...(page.keywords || [])]
        .join(" ")
        .toLowerCase();

      if (!haystack.includes(query)) {
        return null;
      }

      return {
        type: "page",
        id: page.id,
        label,
        description,
        path: page.path.replace("{userId}", userId || ""),
      };
    })
    .filter(Boolean)
    .slice(0, 8);
}

export default pageSearchIndex;
